module.exports = __webpack_public_path__ + "img/preview.e8badf29.png";